import { render, staticRenderFns } from "./My.vue?vue&type=template&id=5c7871ff"
import script from "./My.vue?vue&type=script&lang=js"
export * from "./My.vue?vue&type=script&lang=js"
import style0 from "./My.vue?vue&type=style&index=0&id=5c7871ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports